import { Spinner, TooltipHost } from '@fluentui/react';
import { TDataWallet, TCarteraRatioTableProps, TRatiosCarterasData } from '@/screen/Portfolios/File/types/CarteraRatioTypes';
import { parseIsoDate } from '@/utils/DateFormatter';

const BASE_CLASS = "ratios_carteras";

const formatCalculationDate = (dateValue: Date | string | undefined): string | null =>
{
    const parsedDate = parseIsoDate(dateValue);
    if(!parsedDate)
    {
        return null;
    }

    return parsedDate.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
};

const RatioTable: React.FC<TCarteraRatioTableProps> = ({
    ratios,
    resultTable,
    titleCard,
    isLoading
}) => {
    const calculationDate = formatCalculationDate(ratios?.[0]?.data?.[0]?.dateCalculation);

    return (  
        <div className={`${BASE_CLASS}__card__container`}>
                <div className={`${BASE_CLASS}__table__header`}>
                    <h3>{titleCard}</h3>
                    {!isLoading && calculationDate &&
                    (
                        <span>Fecha: {calculationDate}</span>
                    )}
                </div>
                {isLoading
                    ? <Spinner size={3} style={{ padding: "1em" }} />
                    : <div className={BASE_CLASS}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Ratios</th>
                                    {ratios?.map((ratiosCartera: TRatiosCarterasData) =>
                                        <th>{ratiosCartera.name}</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {resultTable?.map((dataWallet: TDataWallet) => (     
                                    <tr>
                                        <td>
                                            <strong>
                                                <TooltipHost content={dataWallet.toolTipHostContent}>
                                                    {dataWallet.ratioName}
                                                </TooltipHost>
                                            </strong>
                                        </td>
                                        {dataWallet.data && dataWallet?.data.map((text: string | number) =>
                                            <td>
                                                {text}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>        
                }
        </div>
    );
};

export default RatioTable;